import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-comp-pro-wa-page-navigation-toggle',
	templateUrl:'./WaPageNavigationToggleProPage.html',
	styles: [],
	styleUrls:['./WaPageNavigationToggleProPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WaPageNavigationToggleProPage
{
	mdContent_407 = `\`\`\`java
import com.jwebmp.webawesome.components.page.WaPageNavigationToggle;
\`\`\``;
	mdContent_408 = `\`\`\`java
new WaPageNavigationToggle<>()
\`\`\``;
}
